import React, { type FunctionComponent } from 'react';

import { Button, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

import RoomsPopupList from './RoomsPopupList';
import { StyledButtonGroup, StyledRowButtonsContainer } from '../styles/styled-components';

interface BreakoutUserRowProps {
    userId: string;
    inBreakoutRoom: boolean;
}

const MoveUser: FunctionComponent<BreakoutUserRowProps> = ({ userId, inBreakoutRoom }) => {
    const { t } = useTranslation('breakout_room');
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };

    return (
        <StyledRowButtonsContainer>
            <StyledButtonGroup>
                <Button
                    color="primary"
                    variant="outlined"
                    size="small"
                    onClick={handleClick}
                    style={{ maxHeight: '24px' }}
                >
                    {t('move-to')}
                </Button>
                <Popover
                    id={t('move-to')}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                >
                    <RoomsPopupList userId={userId} showMainSession={inBreakoutRoom} />
                </Popover>
            </StyledButtonGroup>
        </StyledRowButtonsContainer>
    );
};

export default MoveUser;
